<template>
  <div class="dashboard-card-doppia">

    <div class="col-24 no-padding prima-card" :style="{ background: properties.bgColorUp }">
      <div class="row row-custom">
        <div class="col-6 icona" :style="{ color: properties.iconColorUp }" v-if="(properties.iconaUp !== '')">
          <icon :name="properties.iconaUp" scale="2.2"></icon>
        </div>
        <div class="col-18 no-padding info" v-if="(properties.typeUp === 'Info')">
          <span class="my-value1"> {{ properties.value1Up }}</span>
          <span class="my-value2"> {{ properties.value2Up }}</span>
        </div>
        <div v-else>
          <div class="col-20 titolo" v-if="(properties.iconaUp !== '')">
            {{ properties.titleUp }}
          </div>
          <div class="col-24 titolo" v-if="(properties.iconaUp === '')">
            {{ properties.titleUp }}
          </div>
          <div class="col-24 valore">
            {{ properties.valueUp }}
          </div>
        </div>
      </div>
    </div>
    <div class="col-24 seconda-card" :style="{ background: properties.bgColorDown }">
      <div v-if="(properties.typeDown === 'Numero')">
        <div class="col-24 value-numerico">
          {{ properties.valueDown }}
        </div>
      </div>
      <div class="row row-custom" v-if="(properties.typeDown === 'Title')">
        <div class="col-6 no-padding icona" v-if="(properties.iconaDown !== '')" :style="{ color: properties.iconColorDown }"  >
          <icon :name="properties.iconaDown" scale="1.5"></icon>
        </div>
        <div class="col-8 no-padding no-padding titolo" v-else >
          {{ properties.titleDown }}
        </div>
        <div class="no-padding my-value" :class="properties.iconaDown !== '' ? 'col-18' : 'col-6 col-16'">
          {{ properties.valueDown }}
        </div>
      </div>
      <div class="row row-custom" v-if="(properties.typeDown === '')">
        <div class="col-lg-6 no-padding icona" :style="{ color: properties.iconColorDown }" v-if="(properties.iconaDown !== '')" >
          <icon :name="properties.iconaDown" scale="1.5"></icon>
        </div>
        <div class="no-padding my-value" :class="properties.iconaDown === '' ? 'col-16 col-lg-24' : 'col-18 col-lg-18'">
          {{ properties.valueDown }}
        </div>
      </div>
    </div>

  </div>
</template>

<script>
  export default {
    name: 'DashboardCardDoppia',
    filters: {
      formatDate: function (date) {
        if (date == '') {
          return ' '
        }
        return (date.substr(0, 2) + '/' + date.substr(2, 2) + '/' + date.substr(4, 4))
      }
    },
    props: {
      properties: {
        type: Object,
        required: true,
        default: function () {
          return {
            bgColorUp: '#007c74',
            bgColorDown: '#007c74',
            iconColor: 'white',
            titleUp: 'Titolo',
            titleDown: 'Titolo',
            iconaUp: 'riv-tick',
            iconaDown: 'riv-tick',
            valueUp: '0',
            valueDown: '0'
          }
        }
      }
    },
    data () {
      return {}
    },
    methods: {}
  }
</script>

<style lang="less">
  @import "../../assets/less/general.less";

  .dashboard-card-doppia {
    .prima-card {
      height: 70px;
      border-radius: 4px;
      .icona {
        height: 70px;
        line-height: 70px;
        text-align: left;
        margin-left: -3px;
        padding: 0px 10px !important;
        .fa-icon {
          vertical-align: middle;
        }
      }
      .titolo {
        height: 40px;
        line-height: 40px;
        font-family: "os-regular";
        font-weight: normal;
        .set-font(@size: 18px, @color: @white);
        text-align: left;/*
        line-height: 70px;
        .set-font(@size: 17px, @color: @white);
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;*/
      }
      .valore {
        height: 30px;
        line-height: 30px;
        .set-font(@size: 14px, @color: @white);
        text-align: right;
        //padding: 0px 10px 0px 0px;
      }
      .info {
        line-height: 70px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        .my-value1 {
          .set-font(@size: 14px, @color: @white, @family: 'os-light');
          text-align: right;
          line-height: 20px;
          display: block;
          padding-right: 5px;
          padding-top: 15px;
        }
        .my-value2 {
          .set-font(@size: 17px, @color: @white, @family: 'os-light');
          text-align: right;
          line-height: 30px;
          display: block;
          padding-right: 5px;
        }

      }
    }
    .seconda-card {
      height: 45px;
      margin-top: 5px;
      border-radius: 4px;
      .icona {
        //margin-top: 8px;
        //padding-top: 8px;
        height: 45px;
        line-height: 40px;
        text-align: left;
        .fa-icon {
          vertical-align: middle;
        }
        //padding: 0px 10px !important;
      }
      .titolo {
        line-height: 45px;
        .set-font(@size: 14px, @color: @white);
        text-align: left;
        //padding: 0px 0px 0px 5px;
      }
      .my-value {
        line-height: 45px;
        .set-font(@size: 20px, @color: @white, @family: 'os-light');
        text-align: right;
        //padding: 0px 5px 0px 0px;
      }
      .value-numerico {
        line-height: 45px;
        .set-font(@size: 20px, @color: @white);
        text-align: center;
        display: block;
      }
    }
  }

  @media screen and (max-width: 1400px) and (min-width: 1250px) {
    .dashboard-card-doppia {
      .prima-card {
        .titolo {
          line-height: 70px;
          .set-font(@size: 16px, @color: @white);
        }
      }
    }
  }

  @media screen and (max-width: 991px) and (min-width: 768px) {
    .dashboard-card-doppia {
      .prima-card {
        .titolo {
          line-height: 70px;
          .set-font(@size: 15px, @color: @white);
        }
        .valore {
          .set-font(@size: 20px, @color: @white);
        }
      }
      .seconda-card {
        .value-numerico {
          .set-font(@size: 17px, @color: @white);
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/ServiceComponents/DashboardCardDoppia.vue